import { useFormStatus } from "react-dom";
import type { ReactNode } from "react";
import { Button } from "@swot/base-components";

export type SwotSubmitButtonProps = {
  readonly children?: ReactNode | undefined;
  readonly pending?: boolean | undefined;
  readonly disabled?: boolean | undefined;
  readonly useFormStatusPending?: boolean | undefined;
  readonly className?: string | undefined;
};

export function SwotSubmitButton(props: SwotSubmitButtonProps) {
  const status = useFormStatus();
  const pending = props.useFormStatusPending ? status.pending : Boolean(props.pending);
  const disabled = Boolean(props.disabled || pending);
  return (
    <Button intent="submit" variant="primary" className={["swot-submit-button", props.className].filter(Boolean).join(" ")} disabled={disabled} loading={pending}>
      {pending ? "Submitting..." : props.children ?? "Submit"}
    </Button>
  );
}
